import { render, staticRenderFns } from "./PriceSection.vue?vue&type=template&id=730b8a68&"
import script from "./PriceSection.vue?vue&type=script&lang=js&"
export * from "./PriceSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports